<app-modal-container>
  <div class="email-send-modal">
    <h2 class="email-send-modal__title">Email envoyé !</h2>
    <p class="email-send-modal__message">
      L'export du leaderboard a été envoyé sur votre boite mail avec succès.
    </p>
    <div class="email-send-modal__actions">
      <kin-btn (onClick)="onClose()">Fermer</kin-btn>
    </div>
  </div>
</app-modal-container>
